import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CookieConsentService } from '../../../core/privacy/cookie-consent.service';

@Component({
  selector: 'app-cookie-notice',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (consent.ready() && !consent.hasChoice()) {
    <aside class="cookie-notice" aria-labelledby="cookie-notice-title">
      <div>
        <h2 id="cookie-notice-title">Sua escolha de privacidade</h2>
        <p>
          Usamos armazenamento necessário para conta, carrinho e ingressos. Com
          sua autorização, também podemos medir a navegação e enviar lembretes
          de compras não concluídas. Publicidade está desativada.
        </p>
        <a routerLink="/politica-de-privacidade"
          >Leia a Política de Privacidade</a
        >
      </div>
      <div class="cookie-actions">
        <button
          class="button secondary"
          type="button"
          (click)="consent.save(false, false)"
        >
          Rejeitar opcionais
        </button>
        <a class="button secondary" routerLink="/preferencias-de-cookies"
          >Configurar</a
        >
        <button class="button" type="button" (click)="consent.save(true, true)">
          Aceitar métricas e recuperação
        </button>
      </div>
    </aside>
    }
  `,
  styles: [
    `
      .cookie-notice {
        position: fixed;
        bottom: 16px;
        left: 16px;
        right: 16px;
        z-index: 30;
        max-width: 1208px;
        margin: auto;
        background: white;
        border: 1px solid var(--color-border);
        border-radius: var(--radius-lg);
        box-shadow: var(--shadow-card);
        padding: 20px;
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 20px;
      }
      h2 {
        font-size: 18px;
        margin: 0 0 8px;
      }
      p,
      a {
        font-size: 13px;
      }
      a {
        color: #4338ca;
      }
      .cookie-actions {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        align-items: center;
      }
      .button {
        min-height: 44px;
        font-size: 13px;
      }
      @media (max-width: 900px) {
        .cookie-notice {
          grid-template-columns: 1fr;
          padding: 16px;
          max-height: 65vh;
          overflow-y: auto;
          bottom: 8px;
          left: 8px;
          right: 8px;
          gap: 12px;
        }
        .cookie-actions > * {
          flex: 1 1 130px;
        }
      }
    `,
  ],
})
export class CookieNoticeComponent {
  protected readonly consent = inject(CookieConsentService);
}
